export default __webpack_public_path__ + "static/simply-debt-smart-logo-a1d71d5edc91b1adbc7c4d518535909d.svg";